import React, { useState } from 'react';

function Onboarding({ onDone }) {
  const [step, setStep] = useState(0);

  const steps = [
    {
      number: '1',
      title: 'Подключите банк',
      text: 'Подключите Сбер или Точку, чтобы Khepri видел реальные поступления и списания. Это можно сделать в разделе «Банки».',
    },
    {
      number: '2',
      title: 'Проверьте прогноз',
      text: 'Khepri предскажет кассовые разрывы на 14 дней вперёд и предупредит о рисках. Всё это — на главном экране.',
    },
    {
      number: '3',
      title: 'Следите за налогами',
      text: 'Налоговый календарь напомнит о платежах, а ИИ найдёт льготы для вашего бизнеса. Всё это — в разделе «Налоги».',
    },
  ];

  return (
    <div style={{ textAlign: 'center', padding: 40, background: '#1E293B', borderRadius: 12, maxWidth: 500, margin: '40px auto', border: '1px solid #8A6636' }}>
      <div style={{
        width: 80,
        height: 80,
        margin: '0 auto 16px',
        borderRadius: '50%',
        background: '#F7DE8A',
        color: '#0F172A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 36,
        fontWeight: 700,
      }}>
        {steps[step].number}
      </div>
      <h2 style={{ marginBottom: 8, color: '#F7DE8A' }}>{steps[step].title}</h2>
      <p style={{ color: '#94A3B8', marginTop: 12, marginBottom: 24, fontSize: 15, lineHeight: 1.6 }}>
        {steps[step].text}
      </p>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
        {step > 0 && (
          <button onClick={() => setStep(step - 1)} style={{ padding: '10px 24px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            Назад
          </button>
        )}
        {step < 2 ? (
          <button onClick={() => setStep(step + 1)} style={{ padding: '10px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>
            Далее
          </button>
        ) : (
          <button onClick={onDone} style={{ padding: '10px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>
            Начать работу
          </button>
        )}
      </div>

      <div style={{ marginTop: 16, display: 'flex', gap: 6, justifyContent: 'center' }}>
        {steps.map((_, i) => (
          <div key={i} style={{ width: i === step ? 24 : 8, height: 8, borderRadius: 4, background: i === step ? '#F7DE8A' : '#8A6636', transition: 'all 0.3s' }} />
        ))}
      </div>

      <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: '#94A3B8', fontSize: 13 }}>Шаг {step + 1} из 3</span>
        <button onClick={onDone} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
          Пропустить
        </button>
      </div>
    </div>
  );
}

export default Onboarding;